import './App.css';
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Backdrop } from '@mui/material';

import { Routes, Route, Link } from "react-router-dom";

import PageDemand from './PageDemand.js'
import PageTram from './PageTram.js'
import {Cycling, Trucks, Cars} from './PageRoadCounts.js';
import PublicTransportStops from './PublicTransport.js';
import BusMap from './BusMap.js';
import PageChargy from  './PageChargy.js';
import Layout from './Layout.js';
import PageTrain from './PageTrain.js';
import Fleet from './PageFleet.js';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="busmap" element={<WithAvailabilityNotice><BusMap /></WithAvailabilityNotice>} />
        <Route path="tram" element={<WithAvailabilityNotice><PageTram /></WithAvailabilityNotice>} />
        <Route path="railway" element={<WithAvailabilityNotice><PageTrain /></WithAvailabilityNotice>} />
        <Route path="demand" element={<PageDemand />} />
        <Route path="cartraffic" element={<WithAvailabilityNotice><Cars /></WithAvailabilityNotice>} />
        <Route path="trucktraffic" element={<WithAvailabilityNotice><Trucks /></WithAvailabilityNotice>} />
        <Route path="cycling" element={<WithAvailabilityNotice><Cycling /></WithAvailabilityNotice>} />
        <Route path="charging" element={<WithAvailabilityNotice><PageChargy /></WithAvailabilityNotice>} />
        <Route path="fleet" element={<WithAvailabilityNotice><Fleet /></WithAvailabilityNotice>} />
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  );
}


function Home() {
  return (
    <div>
      <h2>Welcome</h2>
      <Typography variant="body1">
        Observatoire digital de la mobilité, at your service!
      </Typography>
      <img src="ObsMob_simplified.svg" alt="Fancy conceptual artwork" />

    </div>
  );
}



function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}



const AvailabilityNotice = () => (
  <Card sx={{ maxWidth: 500, backgroundColor: '#f5f5f5', p: 2 }}>
    <CardContent>
      <Typography variant="h6" component="div" gutterBottom>
        Refonte en cours
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Une nouvelle version du dashboard arrive en septembre 2025. D’ici là, les dashboards OdM sont indisponibles.
      </Typography>
    </CardContent>
  </Card>
);

const WithAvailabilityNotice = ({
  mode='replace',
  children,
}) => {
  if (mode === 'disabled') {
    return children
  }
  if (mode === 'replace') {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <AvailabilityNotice />
      </Box>
    );
  }

  return (
    <Box position="relative">
      {children}
      {mode === 'overlay' && (
        <Backdrop
          open
          sx={{
            position: 'absolute',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: '#000',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AvailabilityNotice />
        </Backdrop>
      )}
    </Box>
  );
};